/* ArtsBouquet home – gentle scroll parallax for [data-par] images */
(function () {
  if (window.__abPar) return; window.__abPar = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function run() {
    ticking = false;
    var vh = window.innerHeight;
    document.querySelectorAll('[data-par]').forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1 around centre
      var k = parseFloat(el.getAttribute('data-par')) || 0.1;
      el.style.transform = 'translate3d(0,' + (p * k * 100).toFixed(1) + 'px,0)';
    });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  run();
})();
